import{IconCheckmark300 as e}from"../src/elements/IconCheckmark300.js";customElements.define("sp-icon-checkmark300",e);
//# sourceMappingURL=sp-icon-checkmark300.js.map
